import {
  Box,
  Button,
  FormControl,
  HStack,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from '@chakra-ui/react';
import moment from 'moment';
import { useState } from 'react';
import { getManifesto } from 'services/app';
import { IManifesto } from 'shared/models/manifesto';

const ManifestoBusca = () => {
  const toast = useToast();
  const [searchValue, setSearchValue] = useState('');
  const [manifesto, setManifesto] = useState<IManifesto | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!searchValue.trim()) {
      toast({
        title: 'Digite um valor para buscar',
        status: 'warning',
        duration: 3000,
      });
      return;
    }

    setLoading(true);
    try {
      const res = await getManifesto(searchValue.trim());
      setManifesto(res.data);
    } catch (error) {
      toast({
        title: 'Manifesto não encontrado',
        status: 'error',
        duration: 3000,
      });
      setManifesto(null);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Stack>
      <Text fontWeight="500" color="gray.500">
        Consultar Manifesto
      </Text>

      <HStack>
        <FormControl maxWidth="300px">
          <Input
            placeholder="Digite o número de protocolo"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleKeyPress}
          />
        </FormControl>
        <Button
          colorScheme="blue"
          onClick={handleSearch}
          isLoading={loading}
          size="md"
        >
          Buscar
        </Button>
      </HStack>

      {manifesto && (
        <Box mt="1rem" overflowX="auto">
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Motivo</Th>
                <Th>Nº Protocolo</Th>
                <Th>Data</Th>
                <Th>Hora</Th>
                <Th>Mais detalhes</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td maxW="250px" isTruncated title={manifesto.xMotivo}>
                  {manifesto.xMotivo}
                </Td>
                <Td>{manifesto.nProt}</Td>
                <Td>{moment(manifesto.dhRegEvento).format('DD/MM/YYYY')}</Td>
                <Td>{moment(manifesto.dhRegEvento).format('HH:mm:ss')}</Td>
                <Td>
                  <Popover placement="left">
                    <PopoverTrigger>
                      <Button size="xs" variant="outline" colorScheme="blue">
                        Mais detalhes
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent>
                      <PopoverArrow />
                      <PopoverCloseButton />
                      <PopoverHeader fontWeight="bold">Detalhes</PopoverHeader>
                      <PopoverBody>
                        <Stack spacing={2}>
                          <Box>
                            <Text fontSize="xs" color="gray.500">
                              Status
                            </Text>
                            <Text fontSize="sm">{manifesto.cStat}</Text>
                          </Box>
                          <Box>
                            <Text fontSize="xs" color="gray.500">
                              Chave NFe
                            </Text>
                            <Text fontSize="sm" wordBreak="break-all">
                              {manifesto.chNFe || '-'}
                            </Text>
                          </Box>
                        </Stack>
                      </PopoverBody>
                    </PopoverContent>
                  </Popover>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>
      )}
    </Stack>
  );
};

export default ManifestoBusca;
